<template>
  <div class="permission-form">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <b-card
            header-tag="header"
            footer-tag="footer">
            <div slot="header">
              <i className="fa fa-align-justify"></i><strong>{{ $t('edit') }}</strong>
              <div class="card-actions">
              </div>
            </div>
            <b-form class="row" v-if="item.uuid != null">

              <b-col cols="9" align-self="center">
                <b-form-group v-bind:label="$t('name')" :label-cols="3" :horizontal="true">
                  <b-form-input class="form-control" v-model="item.name"
                                aria-describedby="nameFeedback">
                  </b-form-input>
                </b-form-group>
                <b-form-group v-bind:label="$t('description')" :label-cols="3" :horizontal="true">
                  <b-form-input class="form-control" v-model="item.description">
                  </b-form-input>
                </b-form-group>
                <b-form-group v-bind:label="$t('code')" :label-cols="3" :horizontal="true">
                  <b-form-input class="form-control" v-model="item.code" readonly>
                  </b-form-input>
                </b-form-group>
                <b-form-group v-bind:label="$t('active')" label-cols="3" :horizontal="true">
                  <c-switch type="icon" variant="primary" v-bind="{on: '\uf00c', off: '\uf00d'}" v-model="item.active"
                            v-bind:checked="item.active" :value="1" :uncheckedValue="0"/>
                </b-form-group>

              </b-col>
            </b-form>
            <div slot="footer" class="text-center">
              <router-link :to="{name: model + '_list'}">
                <b-button variant="default"><i class="fa fa-arrow-left"></i> {{$t('back')}}</b-button>
              </router-link>
              <b-button variant="success" v-on:click="updateItem" v-if="uuid != null && $auth.check(model + '.update')">
                <i class="fa fa-save"></i> {{$t('update')}}
              </b-button>
              <b-button variant="success" v-on:click="createItem" v-if="uuid == null && $auth.check(model + '.create')">
                <i class="fa fa-save"></i> {{$t('save')}}
              </b-button>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<style scoped>
  .switch {
    margin-bottom: 0px;
    margin-top: 7px;
    float: left;
    margin-right: 5px;
  }
</style>
<script>
  import cSwitch from '../../../components/Switch'
  import {get, create, update} from '@/api/permission'

  export default {
    name: 'PermissionForm',
    props: {
      uuid: {
        type: String,
        default: null
      }
    },
    components: {
      cSwitch
    },
    computed: {},
    data: function () {
      return {
        model: 'permission',
        item: {
          uuid: null,
          name: '',
          description: '',
          code: '',
          active: 0
        },
        languages: Object.keys(this.$i18n.messages)
      }
    },
    methods: {
      /**
       * Get details of object
       */
      getDetails() {
        this.$Progress.start()
        let data = {
          uuid: this.uuid
        }
        get(data).then((response) => {
          this.item = response.data.data
        }).catch((error) => {
          this.$notify({
            title: this.$t('error'),
            text: error.data.message,
            type: 'error'
          })
        }).then(() => {
          this.$Progress.finish()
        })
      },
      /**
       * Update item info to server
       */
      updateItem() {
        this.$Progress.start()
        update(this.item).then((response) => {
          this.$Progress.finish()
          this.$notify({
            title: this.$t('success'),
            text: response.data.message,
            type: 'success'
          })
          this.$router.push({name: this.model})
        }).catch((error) => {
          this.$Progress.fail()
          this.$notify({
            title: this.$t('error'),
            text: error.data.message,
            type: 'error'
          })
        }).then(() => {
          this.$Progress.finish()
        })
      },
      /**
       * Create item info to server
       */
      createItem() {
        this.$Progress.start()
        create(this.item).then((response) => {
          this.$notify({
            title: this.$t('success'),
            text: response.data.message,
            type: 'success'
          })
          this.$router.push({name: this.model})
        }).catch((error) => {
          this.$notify({
            title: this.$t('error'),
            text: error.data.message,
            type: 'error'
          })
        }).then(() => {
          this.$Progress.finish()
        })
      }
    },
    created: function () {
      if (this.uuid != null) {
        this.getDetails()
      } else {
        this.item.uuid = ''
      }
    },
    watch: {
      'item.name': function () {
        if (this.item.uuid == '') {
          this.item.code = this.item.name.trim().toLowerCase().replace(/ /g, '.')
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/admin/permission/Form.vue